// extracted by mini-css-extract-plugin
module.exports = {"Charts":"Charts_Charts__2-GO3"};